import { usePagination } from '@hooks';
import { PaginationMetadata } from '@modules/usersManagment/data/useGetAllUsersPaginated';
import { NamelessCardBulk } from '../constants';
import { NamelessCardBulkDetailResult } from '../detail/constants';

interface NamelessCardBulkDetailResponse extends PaginationMetadata {
  page: NamelessCardBulkDetailResult[];
  status: NamelessCardBulk['status'];
  attemptedAmount: number;
  dispersedAmount: number | null;
  dispersedCount: number;
}

/**
 * Fetches paginated nameless card bulk detail by dispersion id.
 */
const useNamelessCardBulkDetail = ({
  dispersionId,
  params,
  setURLparams,
}: {
  dispersionId?: string;
  params: object;
  setURLparams: () => void;
}) => {
  const key = dispersionId ? `/v4/nameless-cards/details/${dispersionId}` : false;
  const { data: paginatedData, ...props } = usePagination(key, {
    shouldFetchWithoutParams: true,
    params,
    setURLparams,
    paramKeys: ['page', 'limit'],
  });

  const data = paginatedData as NamelessCardBulkDetailResponse | undefined;
  return { data, ...props };
};

export default useNamelessCardBulkDetail;
